import { render, staticRenderFns } from "./VehicleValidationCard.vue?vue&type=template&id=402044b8&"
import script from "./VehicleValidationCard.vue?vue&type=script&lang=js&"
export * from "./VehicleValidationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports